
import React, { useState } from 'react';
import { Project } from '../../types';

export const ResearchModal = ({ isOpen, onClose, onRun, project, foundNames }: { isOpen: boolean; onClose: () => void; onRun: (term: string) => void; project: Project | null; foundNames: string[] }) => {
  const [term, setTerm] = useState('');
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md">
        <h3 className="text-lg font-bold text-slate-900 mb-2">Deep Research Target</h3>
        <p className="text-xs text-slate-500 mb-4">Enter a company name to research using Google Search.</p>
        
        <input 
          autoFocus
          className="w-full bg-slate-50 border border-slate-300 rounded-lg px-4 py-2 mb-4 focus:ring-2 focus:ring-blue-500 outline-none"
          placeholder="e.g. Acme Corp"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          list="found-names"
        />
        <datalist id="found-names">
            {foundNames.map((name, i) => <option key={i} value={name} />)}
        </datalist>

        <div className="flex justify-end gap-2">
           <button onClick={onClose} className="px-4 py-2 text-sm text-slate-500 hover:text-slate-800">Cancel</button>
           <button onClick={() => { if(term) onRun(term); }} disabled={!term} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 font-medium">
             Start Research
           </button>
        </div>
      </div>
    </div>
  );
};
    